import { useState } from 'react';

const useCustomHook = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  return {
    isLoading,
    setIsLoading,
    openDialog,
    setOpenDialog,
  };
};

export default useCustomHook;
